import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { and, PrivateRoute, Roles } from '@/js/libs/use-auth';

import { PrintSearchParams } from 'src/scenes/PrintOperations/containers/Print/types.ts';
import PrintOperations from 'src/scenes/PrintOperations/index.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const printOperationsRouteObject = inferRouteObject({
  path: 'print-operations',
  element: <PrivateRoute roles={and(Roles.MANAGE_PRINT_PRODUCTS, Roles.PRINT_OPS_PUSH)} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: PrintOperations.Helmet,
      children: [
        {
          path: 'print',
          searchParams: PrintSearchParams.parse,
          children: [
            {
              index,
              Component: PrintOperations.Print,
            },
          ],
        },
        {
          path: 'extracted-labels',
          Component: PrintOperations.ExtractedLabels,
        },
        {
          path: 'publication-upload',
          Component: PrintOperations.PublicationUpload,
        },
        {
          index,
          element: <Navigate to='./print' replace />,
        },
      ],
    },
  ],
});
